import { render } from "./AccountSettingAboutTermIndex.vue?vue&type=template&id=0a81cee9"
import script from "./AccountSettingAboutTermIndex.vue?vue&type=script&lang=js"
export * from "./AccountSettingAboutTermIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__